import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ClockIcon, AlertIcon } from '../../assets/imageAssets';
import { X } from "@untitledui/icons/X";
import { closeModal, openModals } from "../../redux/modal.slice";
import ModalsEnum from '../../enums/modal.enum';

const CancelSubscriptionModal = ({modalData}) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.me.data);
    const isPauseScheduled = user?.user_premium_status?.pause_scheduled;
    const handleClose = () => {
        dispatch(closeModal());
    }

    const handlePausePlan = () => {
        dispatch(closeModal());
        dispatch(
            openModals({
                modalIds: [ModalsEnum.PAUSE_SUBSCRIPTION_MODAL],
                modalData: [
                    {
                        className: 'small-centered-modal',
                    }
                ]
            })
        );
    }

    const handleCancelAndDowngrade = () => {
        dispatch(closeModal());
        dispatch(
            openModals({
                modalIds: [ModalsEnum.CONFIRM_CANCELATION_MODAL],
                modalData: [
                    {
                        className: 'small-centered-modal',
                    }
                ]
            })
        );
    }

    return (
        <>
            <div className='modal-header mb-32'>
                <h2 className='mb-8'>Cancel Subscription</h2>
                <h6>Would you like to pause or cancel your subscription?</h6>
                <button className='close-modal-button' onClick={handleClose}>
                    <X />
                </button>
            </div>
            <div className="modal-body flex flex-between">
                <div className='cancel-subscription-card pause-card'>
                    <div className="cancel-subscription-card__content flex flex-align-start">
                        <div className='icon'>
                            <img src={ClockIcon} alt="Clock Icon" />
                        </div>
                        <div>
                            <h4>Pause for 30 days</h4>
                            <p>Take a short break. Your access will resume automatically after 30 days.</p>
                            <ul>
                                <li>Keep Premium Features</li>
                                <li>Resume Anytime</li>
                                <li>No Charges During Pause</li>
                            </ul>
                        </div>
                    </div>
                    <div className="cancel-subscription-card__footer">
                        <button onClick={handlePausePlan} disabled={isPauseScheduled}>Pause Plan</button>
                    </div>
                </div>
                <div className='cancel-subscription-card cancel-card'>
                    <div className="cancel-subscription-card__content flex flex-align-start">
                        <div className='icon'>
                            <img src={AlertIcon} alt="Alert Icon" />
                        </div>
                        <div>
                            <h4>Cancel Subscription</h4>
                            <p>You will lose access to premium features and be downgraded to the Free Plan.</p>
                            <ul>
                                <li>No AI Quiz Generator</li>
                                <li>No In-depth Explanations</li>
                                <li>Limited Screenshots & Solve</li>
                            </ul>
                        </div>
                    </div>
                    <div className="cancel-subscription-card__footer">
                        <button onClick={handleCancelAndDowngrade}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CancelSubscriptionModal;